import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { InternationalPhoneIcon, ErrorBoldIcon, WarningBoldIcon } from '@pattern-library/icon';
var USFlag = function USFlag(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h513v38H0zM0 76h513v38H0zM0 152h513v38H0zM0 228h513v38H0zM0 304h513v38H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v190H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8 141.9l-4-12.8-4.3 12.8H26.3l10.7 7.7-4 12.8 10.8-7.9 10.7 7.9-4.2-12.8 10.9-7.7zM104.2 141.9l-4.1-12.8-4.2 12.8H82.7l10.7 7.7-4.1 12.8 10.8-7.9 10.7 7.9-4-12.8 10.8-7.7zM160.6 141.9l-4.2-12.8-4 12.8h-13.5l10.9 7.7-4.2 12.8 10.8-7.9 10.9 7.9-4.2-12.8 10.8-7.7zM216.9 141.9l-4.1-12.8-4.2 12.8h-13.2l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4.2-12.8 10.9-7.7zM100.1 78.3l-4.2 12.8H82.7L93.4 99l-4.1 12.6 10.8-7.8 10.7 7.8-4-12.6 10.8-7.9h-13.4zM43.8 78.3l-4.3 12.8H26.3L37 99l-4 12.6 10.8-7.8 10.7 7.8L50.3 99l10.9-7.9H47.8zM156.4 78.3l-4 12.8h-13.5l10.9 7.9-4.2 12.6 10.8-7.8 10.9 7.8-4.2-12.6 10.8-7.9h-13.3zM212.8 78.3l-4.2 12.8h-13.2l10.7 7.9-4 12.6 10.7-7.8 10.8 7.8-4.2-12.6 10.9-7.9h-13.4zM43.8 27.7l-4.3 12.6H26.3L37 48.2l-4 12.7L43.8 53l10.7 7.9-4.2-12.7 10.9-7.9H47.8zM100.1 27.7l-4.2 12.6H82.7l10.7 7.9-4.1 12.7 10.8-7.9 10.7 7.9-4-12.7 10.8-7.9h-13.4zM156.4 27.7l-4 12.6h-13.5l10.9 7.9-4.2 12.7 10.8-7.9 10.9 7.9-4.2-12.7 10.8-7.9h-13.3zM212.8 27.7l-4.2 12.6h-13.2l10.7 7.9-4 12.7 10.7-7.9 10.8 7.9-4.2-12.7 10.9-7.9h-13.4z"
  })));
};
USFlag.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 513 342"
};
import Dropdown from '@pattern-library/dropdown';
import { FormLabelPopover } from '@pattern-library/message-popover';
import { formatIntl, formatUS } from './format';
const KeyCodes = {
  UP: 38,
  DOWN: 40
};
const CountryData = {
  ZZ: {
    code: undefined,
    inputLength: 15
  },
  US: {
    code: '1',
    inputLength: 10
  }
};
const propTypes = {
  /**
   * Element ID
   **/
  id: PropTypes.string.isRequired,
  /**
   * Label
   */
  label: PropTypes.string,
  /**
   * A function that accepts the number as the first arg, country code as the second, and the formatted number as the third
   **/
  onChange: PropTypes.func,
  /**
   * Display the dropdown for selecting US or International
   **/
  international: PropTypes.bool,
  /**
   * Configure the format of international numbers
   */
  internationalFormatOptions: PropTypes.shape({
    allowSpaceAfterCountryCode: PropTypes.bool
  }),
  /**
   * Placeholder for US
   **/
  placeholder: PropTypes.string,
  /**
   * initial phone number
   */
  initialNumber: PropTypes.string,
  /**
   * render the component's error state
   */
  hasError: PropTypes.bool,
  /**
   * error message to display when hasError is true
   */
  errorMessage: PropTypes.string,
  /**
   * The severity of the input's error state
   */
  errorLevel: PropTypes.oneOf(['error', 'warning']),
  /**
   * initial country to display in dropdown
   */
  initialCountry: PropTypes.oneOf(['US', 'ZZ']),
  /**
   * Flag to indicate whether this input is a required field
   */
  isRequired: PropTypes.bool,
  /**
   * Append asterisk to label
   */
  showRequiredAsterisk: PropTypes.bool,
  /**
   * Appended to the text label.
   * Defaults to (optional) for non-required inputs, but can be overridden.
   */
  optionalInputLabel: PropTypes.string,
  /**
   * Text message shown below the input
   */
  subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /**
   * Content for the the message popover component
   */
  infoPopoverContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /**
   * Additional props to pass to the message popover component
   */
  infoPopoverProps: PropTypes.object,
  /**
   * Additional classes for the input element
   */
  inputClass: PropTypes.string
};
const defaultProps = {
  label: 'Phone number',
  international: false,
  internationalFormatOptions: {
    allowSpaceAfterCountryCode: false
  },
  placeholder: '(___) ___-____',
  initialNumber: '',
  hasError: false,
  errorMessage: '',
  initialCountry: 'US',
  isRequired: true,
  showRequiredAsterisk: false,
  optionalInputLabel: '(optional)',
  errorLevel: 'error',
  infoPopoverContent: null,
  infoPopoverProps: {},
  inputClass: ''
};
class PhoneInput extends Component {
  constructor(props) {
    super(props);
    this.setCountry = country => {
      const unformattedNumber = this.getUnformattedNumber(this.state.number, country);
      // It's important that we compute the formatted number from the
      // unformatted number here. If we don't, strange things might happen
      // when switching between countries. Take this corner case:
      //
      // 1. The input allows a space after the country code in international
      //    numbers.
      // 2. The user switches to the international format and types in
      //    "1234". The formatting converts that to "+1234".
      // 3. The user switches to the US format, and the value updates to
      //    "(123) 4".
      // 4. The user switches back to the international format, and this time
      //    the value updates to "+123 4" -- because the US format introduced
      //    a space between "3" and "4", and that's valid for the
      //    international format.
      //
      // By using the unformatted number as input instead, we strip out
      // everything but the digits ahead of time and avoid scenarios like the
      // one above.
      const formattedNumber = this.getFormattedNumber(unformattedNumber, country);
      this.setState({
        number: formattedNumber,
        country: country,
        closeDropdown: true
      });
      if (this.props.onChange) {
        this.props.onChange(unformattedNumber, CountryData[country].code, formattedNumber);
      }
      window.setTimeout(() => {
        this.setState({
          closeDropdown: undefined
        });
        this.inputRef.focus();
        this.inputRef.selectionStart = 0;
        this.inputRef.selectionEnd = this.state.number.length;
      }, 10);
    };
    this.onClick = e => {
      this.setCountry(e.target.value || undefined);
    };
    this.onKeyDown = (e, country) => {
      if (e.keyCode === KeyCodes.DOWN || e.keyCode === KeyCodes.UP) {
        if (country === 'US') {
          this.internationalRef.focus();
        } else {
          this.usRef.focus();
        }
        e.preventDefault();
      }
    };
    this.firstItemFocused = e => {
      if (e.relatedTarget !== this.usRef) {
        if (this.state.country === 'US') {
          this.usRef.focus();
        }
      }
    };
    this.onInputChange = e => {
      let number = e.target.value;
      const country = this.state.country;
      const unformattedNumber = this.getUnformattedNumber(number, country);
      const formattedNumber = this.getFormattedNumber(number, country);
      this.setState({
        number: formattedNumber
      });
      if (this.props.onChange) {
        this.props.onChange(unformattedNumber, CountryData[country].code, formattedNumber);
      }
    };
    this.getDropdownItemMarkup = () => {
      const getButtonProps = country => {
        let inputId = this.props.id + '_' + country;
        return {
          'value': country,
          'id': inputId,
          'name': 'country-code',
          'className': 'asc-phone-input-country-select-button',
          'aria-selected': country === this.state.country,
          'role': 'option',
          'onClick': e => this.onClick(e),
          'onKeyDown': e => this.onKeyDown(e, country)
        };
      };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", _extends({}, getButtonProps('ZZ'), {
        onFocus: e => this.firstItemFocused(e),
        ref: button => {
          this.internationalRef = button;
        },
        type: "button"
      }), "International"), /*#__PURE__*/React.createElement("button", _extends({}, getButtonProps('US'), {
        ref: button => {
          this.usRef = button;
        },
        type: "button"
      }), /*#__PURE__*/React.createElement(USFlag, {
        className: "asc-phone-input-flag"
      }), " United States +1"));
    };
    this.state = {
      number: props.initialNumber,
      country: props.initialCountry,
      closeDropdown: undefined
    };
  }
  getFormattedNumber(value, country) {
    if (country === 'US') {
      return formatUS(value);
    } else {
      return formatIntl(value, this.props.internationalFormatOptions);
    }
  }
  getUnformattedNumber(number, country) {
    return number.replace(/\D/g, '').substring(0, CountryData[country].inputLength);
  }
  render() {
    // all props are defined here, whether they are used or not,
    // in order to prevent them from being passed to the input through inputPassthrough
    const {
      id,
      label,
      onChange,
      // eslint-disable-line no-unused-vars
      international,
      placeholder,
      initialNumber,
      // eslint-disable-line no-unused-vars
      hasError,
      errorMessage,
      initialCountry,
      // eslint-disable-line no-unused-vars
      isRequired,
      showRequiredAsterisk,
      optionalInputLabel,
      subtext,
      errorLevel,
      infoPopoverContent,
      infoPopoverProps,
      internationalFormatOptions,
      // eslint-disable-line no-unused-vars
      inputClass,
      ...inputPassthrough
    } = this.props;
    const {
      number,
      country,
      closeDropdown
    } = this.state;
    const phoneInputClassNames = classNames('asc-phone-input', {
      [`asc-form-input--${errorLevel}`]: hasError
    });
    const ErrorIcon = errorLevel === 'error' ? ErrorBoldIcon : WarningBoldIcon;
    const hasInfoPopover = infoPopoverContent !== null;
    const ids = {
      help: [`${id}-help`, hasError && Boolean(errorMessage)],
      subtext: [`${id}-subtext`, Boolean(subtext)],
      popover: [`${id}-popover`, hasInfoPopover]
    };
    const ariaDescribedByIds = Object.keys(ids).filter(key => ids[key][1]).map(key => ids[key][0]);
    return /*#__PURE__*/React.createElement("div", {
      className: phoneInputClassNames
    }, /*#__PURE__*/React.createElement("label", {
      className: "asc-form-label",
      id: id + '_label',
      htmlFor: id
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames({
        'is-required': isRequired
      })
    }, label), showRequiredAsterisk && isRequired && /*#__PURE__*/React.createElement("span", {
      className: "asc-form-required-asterisk"
    }, "\xA0*"), !isRequired && optionalInputLabel && /*#__PURE__*/React.createElement("span", null, "\xA0", optionalInputLabel)), hasInfoPopover && /*#__PURE__*/React.createElement(FormLabelPopover, {
      messagePopoverId: ids.popover[0],
      messagePopoverContent: infoPopoverContent,
      messagePopoverProps: infoPopoverProps
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames('asc-phone-input-wrapper', 'asc-form-input', inputClass)
    }, international && /*#__PURE__*/React.createElement(Dropdown, {
      id: 'country-select-' + id,
      closeWhen: closeDropdown,
      buttonText: country === 'US' ? /*#__PURE__*/React.createElement(USFlag, {
        "aria-label": "Country code menu. United States selected",
        className: "asc-phone-input-flag"
      }) : /*#__PURE__*/React.createElement(InternationalPhoneIcon, {
        size: "sm",
        color: "dark-gray",
        label: "Country code menu. International selected. Include country code with phone number."
      }),
      content: /*#__PURE__*/React.createElement("div", {
        className: "asc-phone-input-country-code-list",
        role: "listbox"
      }, this.getDropdownItemMarkup())
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: `${inputPassthrough.name ?? id ?? ''}CountryCode`,
      value: country
    }), /*#__PURE__*/React.createElement("input", _extends({
      className: "asc-phone-input-input",
      id: id,
      name: id,
      value: number,
      onChange: e => this.onInputChange(e),
      ref: input => {
        this.inputRef = input;
      },
      inputMode: "numeric",
      placeholder: country === 'US' ? placeholder : '',
      title: CountryData[country].inputLength + ' digit number',
      "aria-describedby": ariaDescribedByIds.length ? ariaDescribedByIds.join(' ') : null
    }, inputPassthrough))), hasError && errorMessage && /*#__PURE__*/React.createElement("div", {
      id: ids.help[0],
      className: "asc-form-help"
    }, /*#__PURE__*/React.createElement(ErrorIcon, {
      className: "asc-form-help-icon",
      customSize: "14px",
      color: errorLevel
    }), /*#__PURE__*/React.createElement("p", {
      className: "asc-form-help--error-message"
    }, errorMessage)), subtext && /*#__PURE__*/React.createElement("p", {
      id: ids.subtext[0],
      className: "asc-form-subtext"
    }, subtext));
  }
}
PhoneInput.propTypes = propTypes;
PhoneInput.defaultProps = defaultProps;
export default PhoneInput;